import { X } from 'lucide-react';

import { Button } from '@/shared/ui/shadcn/button';

/** The subset of an attachment the editor needs to list it. */
export interface DocumentEditorAttachment {
  attachmentId: string;
  filename: string;
}

interface DocumentAttachmentListProps {
  attachments: DocumentEditorAttachment[];
  onRemove(attachmentId: string): void;
}

export function DocumentAttachmentList({ attachments, onRemove }: DocumentAttachmentListProps) {
  if (attachments.length === 0) {
    return null;
  }
  return (
    <div className="border-t px-3 py-2" aria-label="Attachments">
      <p className="mb-1 text-xs font-medium text-muted-foreground">Attachments</p>
      <ul className="space-y-1 text-xs">
        {attachments.map((attachment) => (
          <li key={attachment.attachmentId} className="flex min-w-0 items-center gap-2">
            <span className="min-w-0 flex-1 truncate">{attachment.filename}</span>
            <Button
              type="button"
              size="sm"
              variant="ghost"
              className="h-6 w-6 shrink-0 px-0"
              onClick={() => onRemove(attachment.attachmentId)}
              aria-label={`Remove ${attachment.filename}`}
              title="Remove attachment"
            >
              <X className="size-3.5" />
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
